import { z } from 'zod';
import {
    type NodeSocketCfg,
    baseNodeCfgSchema,
} from './base-node';

export const processStatusNodeCfgSchema = baseNodeCfgSchema.extend({
    kind: z.literal('processStatus'),
    controlValues: z.object({
        processId: z.string().uuid(),
    }),
});
export interface ProcessStatusNodeCfgSchema extends z.infer<typeof processStatusNodeCfgSchema> {}

export const processStatusNodeSocketCfg = {
    controlSockets: {
        inputs: () => ({
            trigger: 'event',
        }),
        outputs: () => ({
            next: 'event',
        }),
    },
    dataSockets: {
        inputs: () => ({
            materialId: 'string',
        }),
        outputs: () => ({
            status: 'string',
            goodCount: 'number',
            requiredCount: 'number',
        }),
    },
} satisfies NodeSocketCfg<ProcessStatusNodeCfgSchema>;
